






























































































































































































































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { ReviewForm, ReviewEntity } from "@/entities";
import * as _ from "lodash";
import AuditComponent from "@/components/common/AuditInfo/AuditInfo.vue";
import { Locales } from "@/i18n/locales";

const namespace: string = "reviewForm";

@Component({
  components: { AuditComponent }
})
export default class ReadOnlyTAGReviewComponent extends Vue {
  @State(namespace) review!: ReviewForm;
  @State("reviewExternal") reviewEntity!: ReviewEntity;
  @Action("getTemplate", { namespace }) getTemplate: any;
  @Action("getData", { namespace }) getData: any;
  @Action("getCategories", { namespace }) getCategories: any;
  @Getter("_appUser", { namespace: "RootApp"}) _username!: string;

  reviewId: any;
  applicationId: any;
  language: any;
  categoryList = [];
  modelData = {};
  applicationInfo = {};
  tagReviewer: string;
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;

  mounted() {
      // get the templates..
    this.getTemplate(1);
    
  }

  /** get the computed property overall score */
  get overallScore() {
    return Object.keys(this.modelData).reduce((sum, key) => {
      sum += this.modelData[key].rating;
      return sum;
    }, 0);
  }

  /** computed property recommendation */

  get recommendation() {
    // TO DO: Should come from configuartion
    const minRating = 3;
    const categoryCnt = Object.keys(this.modelData).length;
    return this.overallScore < categoryCnt * minRating ? "NO" : "YES";
  }

  /** pdf download */
  download() {
    if (this.$route.query && this.$route.query.entity) {
      let entity = this.$route.query.entity.toString();

      this.$services.review.getReportData(this.review.reviewId, entity)
        .then((resp) => {
          if (resp.status >= 200 && resp.status < 300) {
            this.$services.tagReviewReport.generate({
              "data": this.getFormData(),
              "categories": this.categoryList,
              "metadata": resp.data.metadata,
              "user": this._username
            });
          }
        });
    }
  }

  /** Transform and get the form data */

  getFormData() {
    const reviews = Object.keys(this.modelData).reduce(
      (out: any, key: string) => {
        out.push(
          Object.assign({}, { categoryId: parseInt(key) }, this.modelData[key])
        );
        return out;
      },
      []
    );
    let form = {
      reviews,
      override: this.review.override,
      comment: this.review.comment,
      totalScore: this.overallScore,
      overallRating: this.review.overallRating,
      recommendation: this.review.recommendation,
      applicationId: this.review.applicationId,
      reviewerId: this.review.reviewerId,
      version: this.review.version,
      auditInfo: this.review.auditInfo
    };

    return form;
  }

  /** open a read only view of application in new tab */
  openApplication() {
    if (this.$route.query.entity === 'ConceptNote') {
      let routeData = this.$router.resolve({
        name: "viewConceptNote",
        params: {
          conceptNoteId: this.review.applicationId,
          section: "technicalApplication",
        },
      });
      
      window.open(routeData.href, "_blank");
    } else {
      let routeData = this.$router.resolve({
        name: "viewApplication",
        params: {
          appId: this.review.applicationId,
          section: "technicalApplication",
        },
      });

      window.open(routeData.href, "_blank");
    }
  }

  /** Application Review */
  getReviewData(reviewerId: any, aid: any, language: string, entity: string) {
    // this.reviewId = rid;
    this.applicationId = aid;
    this.language = language;
    this.getData({ reviewerId: reviewerId, applicationId: this.applicationId, language: this.language, entity: entity })
    .then(data => {
      if(data) {
        this.tagReviewer = data.review ? data.review.Reviewer : "";
        this.getCategories({id: data.application.ApplicationId, entity: entity}).then(catg => {
          this.categoryList = catg;
          this.transform();
          this.$services.review.getApplicationInfo(data.application.ApplicationId, entity).then(list => {
             this.applicationInfo = list;
          });
        });
      }
    });
  }

  /** transform model data to the desired format */

  transform() {
    this.modelData = this.categoryList.reduce((obj: any, tmpl: any) => {
      obj[tmpl.CategoryId] = { rating: 0, reviewComment: "" };
      if (this.review.reviews) {
        const review = this.review.reviews.find(
          x => x.categoryId == tmpl.CategoryId
        );
        if (review)
          obj[tmpl.CategoryId] = {
            rating: review.rating,
            reviewComment: review.reviewComment
          };
      }
      return obj;
    }, {});
  }

  projectTitle(title: string): string {
    return this.$services.format.formatTitle(title);
  }

  /* watch methods */
  @Watch("$route.query", { immediate: true, deep: true })
  onUrlChange(newVal: any) {
    if(newVal && Object.keys(newVal).length > 0) {
      let reviewerId = parseInt(newVal.reviewerId);
      this.applicationId = newVal.applicationId; // application guid
      let entity = newVal.entity;
      this.getReviewData(reviewerId, this.applicationId, this.review.language, entity);
    }
  }

  back() {
    this.$router.push({
      name: "dashboard",
    });
  }
}
